import { Body1 } from '@sainsburys-tech/luna-typography'
import { IReferenceNumber } from '../../../types/AccidentReportOverview/IAccidentReportOverview'

const ReferenceNumber = ({ referenceNumber } : IReferenceNumber) => {
  return (
    <div>
      <Body1
        className="s-referenceNumber ln-u-color-grey"
        id="s-referenceNumber"
      >
        SIMS Ref: {referenceNumber}
      </Body1>
    </div>
  )
}

export default ReferenceNumber